export function set_syllable_event(
  svg: SVGSVGElement,
  events: { [key: string]: EventListenerOrEventListenerObject },
) {
  const syllables = svg.querySelectorAll('.syllable .bg-rect');
  syllables.forEach((syllable) => {
    for (const eventKey of Object.keys(events)) {
      events[eventKey];
      syllable.addEventListener(eventKey, events[eventKey]);
    }
  });
}

export function find_syllable_group(el: Element) {
  if (el.classList.contains('syllable')) {
    return el;
  }
  return find_syllable_group(el.parentElement!);
}
